export interface SvipMembership {svip?:boolean;svipExpiresAt?:number}
export function isSvipMember(member:SvipMembership,now=Date.now()) {
 return member.svip===true&&(member.svipExpiresAt===undefined||member.svipExpiresAt===0||Number.isFinite(member.svipExpiresAt)&&member.svipExpiresAt!>now);
}
